import { GetUploadPhotoOptions, ModalEventType } from '../analytics-context-types';
import { getModalTag, getPODProductTag } from './utils';

export const getUploadPhotoTag = (options: GetUploadPhotoOptions) => {
  const { product } = getPODProductTag(
    options.productName,
    options.productID,
    options.productType,
    options.productQuantity,
  );
  const photos: ModalEventType[] = [
    {
      eventInfo: {
        eventName: 'photo upload method',
        eventAction: options.uploadMethod,
      },
    },
    {
      eventInfo: {
        eventName: 'userUploadedImage',
        eventAction: `${options.uploadedPhotos.length}`,
      },
    },
  ];
  options.uploadedPhotos.forEach((imageSize, i) => {
    const fileData = options.uploadedPhotosData.at(i);

    if (fileData)
      photos.push({
        eventInfo: {
          eventName: 'photo format',
          eventAction: fileData.format,
        },
      });
    photos.push({
      eventInfo: {
        eventName: 'photo upload size',
        eventAction: `${imageSize}`,
      },
    });
  });

  const uploadPhotoModalEvent = [
    {
      eventInfo: {
        eventName: 'area',
        eventAction: options.elementPosition,
      },
    },
    ...photos,
  ];

  const { modal, user } = getModalTag(options.productType, 'Edit Mode', uploadPhotoModalEvent, options.projectID);

  return {
    modal,
    product,
    user,
  };
};
